<mat-form-field [class]="class">
  <mat-select #matSelect disableOptionCentering [formControl]="selectControl" [placeholder]="label"
      [multiple]="isMultiple" (selectionChange) ="selectionchange($event)" [disabled]="disabled">

      <np-mat-select-search [formControl]="filterControl" [selectControl]="selectControl"
          placeholderLabel="Search {{label}}" noEntriesFoundLabel="No {{label || 'Options'}} Found">
      </np-mat-select-search>

      <!-- Select All -->
      <np-mat-select-check *ngIf="isMultiple" class="select-hybrid-parent" [selectControl]="selectControl"
          [values]="filteredData" [dataKey]="dataKey">
      </np-mat-select-check>

      <!-- None option for single select -->
      <mat-option *ngIf="!isMultiple && hasNone" selected>{{noneLabel}}</mat-option>
      <mat-option *ngIf="!isMultiple && hasAll" selected [value]="0">All</mat-option>
      <ng-container *ngIf="dataKey && dataDisplayValue">
          <mat-option *ngFor="let item of filteredData" [value]="item[dataKey]">
              {{item[dataDisplayValue]}}
          </mat-option>
      </ng-container>
      <ng-container *ngIf="!dataKey || !dataDisplayValue">
          <mat-option *ngFor="let item of filteredData" [value]="item">
              {{item}}
          </mat-option>
      </ng-container>
  </mat-select>
</mat-form-field>
